import _slicedToArray from "@babel/runtime-corejs3/helpers/esm/slicedToArray";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import translations from './SessionTimeoutDialogComponentMessages';
import { ID } from './constants';
var SessionTimeoutCountDown = function SessionTimeoutCountDown(_ref) {
  var inactivityDialogCount = _ref.inactivityDialogCount,
    onSignOutAndRedirectToLogin = _ref.onSignOutAndRedirectToLogin;
  var intl = useIntl();
  var timer;
  var minuteCountInit = inactivityDialogCount >= 60 ? Math.floor(inactivityDialogCount / 60) : 0;
  var secondCountInit = inactivityDialogCount % 60;
  var _useState = useState({
      minutes: minuteCountInit,
      seconds: secondCountInit
    }),
    _useState2 = _slicedToArray(_useState, 2),
    time = _useState2[0],
    setTime = _useState2[1];
  var countDownIsZeroAction = function countDownIsZeroAction() {
    clearInterval(timer);
    onSignOutAndRedirectToLogin(true);
  };
  var countDownTimeUpdate = function countDownTimeUpdate() {
    setTime(function (previousTime) {
      var minutes = previousTime.minutes,
        seconds = previousTime.seconds;
      return {
        minutes: minutes > 0 && seconds === 0 ? minutes - 1 : minutes,
        seconds: minutes > 0 && seconds === 0 ? 59 : seconds - 1
      };
    });
  };
  useEffect(function () {
    timer = setInterval(countDownTimeUpdate, 1000);
    return function () {
      clearInterval(timer);
    };
  }, []);
  useEffect(function () {
    var minutes = time.minutes,
      seconds = time.seconds;
    if (minutes === 0 && seconds === 0) {
      countDownIsZeroAction();
    }
  }, [time]);
  var minutes = time.minutes,
    seconds = time.seconds;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    "data-testid": ID.SESSION_TIMEOUT_MODAL_DIALOG_INFORMATIONAL_MESSAGE_ID
  }, intl.formatMessage(translations.primaryMsg)), /*#__PURE__*/React.createElement("p", {
    "data-testid": ID.SESSION_TIMEOUT_MODAL_DIALOG_COUNTDOWN_TIMER_ID
  }, intl.formatMessage(translations.timerHeading), /*#__PURE__*/React.createElement("b", {
    role: "timer"
  }, /*#__PURE__*/React.createElement("span", null, minutes < 10 ? " 0".concat(minutes) : minutes), minutes < 2 ? /*#__PURE__*/React.createElement("span", null, ":", seconds < 10 ? "0".concat(seconds) : "".concat(seconds)) : null)));
};
SessionTimeoutCountDown.propTypes = process.env.NODE_ENV !== "production" ? {
  inactivityDialogCount: PropTypes.number.isRequired,
  onSignOutAndRedirectToLogin: PropTypes.func.isRequired
} : {};
export default /*#__PURE__*/React.memo(SessionTimeoutCountDown);